"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInfo = exports.Account = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Card = __importStar(require("../card/card"));
const react_i18next_1 = require("react-i18next");
const typography_1 = require("../../shared/typography");
const buttons_1 = require("../../atoms/buttons");
const SpaceBetween = styled_components_1.default.div `
  align-items: flex-start;
  display: flex;
  justify-content: space-between;

  p,
  h2 {
    margin-bottom: 0;
  }

  p {
    padding: ${({ theme }) => `0 ${theme.spacings.xl} 0 ${theme.spacings.xl}`};
    text-align: left;
    word-break: break-word;
  }

  & > button {
    padding: 0;
    width: auto;
  }

  & > h2 + button {
    font-weight: 500 !important;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    p {
      padding-left: ${({ theme }) => theme.spacings.xxs};
    }
  }
`;
const LastRow = (0, styled_components_1.default)(Card.Row) `
  margin-bottom: ${({ theme }) => theme.spacings.xs};
`;
const Account = ({ email, onEmailChange, onPasswordChange, disabled }) => {
    const { t } = (0, react_i18next_1.useTranslation)("md");
    return ((0, jsx_runtime_1.jsx)(Card.Container, { title: t("memberDetails.cards.account.title"), children: (0, jsx_runtime_1.jsxs)(Card.Row, { children: [(0, jsx_runtime_1.jsxs)(Card.Row, { children: [(0, jsx_runtime_1.jsx)(Card.Column, { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: t("memberDetails.cards.account.email") }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(Card.Column, { children: (0, jsx_runtime_1.jsxs)(SpaceBetween, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: email }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "transparent", onClick: onEmailChange, disabled: disabled, children: t("memberDetails.cards.account.btnChange") }, void 0)] }, void 0) }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(LastRow, { children: [(0, jsx_runtime_1.jsx)(Card.Column, { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: t("memberDetails.cards.account.password") }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(Card.Column, { children: (0, jsx_runtime_1.jsxs)(SpaceBetween, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: "*******" }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "transparent", onClick: onPasswordChange, disabled: disabled, children: t("memberDetails.cards.account.btnChange") }, void 0)] }, void 0) }, void 0)] }, void 0)] }, void 0) }, void 0));
};
exports.Account = Account;
const renderMemberDetails = (member, t) => {
    const details = [];
    for (const detail in member) {
        details.push((0, jsx_runtime_1.jsxs)(Card.Row, { children: [(0, jsx_runtime_1.jsx)(Card.Column, { children: t(`memberDetails.cards.personalInfo.${detail}`) }, void 0), (0, jsx_runtime_1.jsx)(Card.Column, { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: member[detail] }, void 0) }, void 0)] }, detail));
    }
    return details;
};
const PersonalInfo = ({ onPersonalDataChange, member, disabled }) => {
    const { t } = (0, react_i18next_1.useTranslation)("md");
    return ((0, jsx_runtime_1.jsx)(Card.Container, { title: (0, jsx_runtime_1.jsxs)(SpaceBetween, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: t("memberDetails.cards.personalInfo.title") }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "transparent", onClick: onPersonalDataChange, disabled: disabled, children: t("memberDetails.cards.personalInfo.btnChange") }, void 0)] }, void 0), children: (0, jsx_runtime_1.jsx)(Card.Row, { children: (0, jsx_runtime_1.jsx)(PersonalInfoWrapper, { children: renderMemberDetails(member, t) }, void 0) }, void 0) }, void 0));
};
exports.PersonalInfo = PersonalInfo;
const PersonalInfoWrapper = styled_components_1.default.div `
  & > div > div {
    text-align: left !important;
  }

  & > div:last-of-type {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }

  & > div > div:last-of-type {
    padding-left: ${({ theme }) => theme.spacings.xl};
  }
`;
//# sourceMappingURL=MemberDetails.js.map